import React from 'react';
import QueryBuilder from '../QueryBuilder/QueryBuilder';

const Formula = ({
  variantInfo = null,
  typoIndex,
  variantIndex,
  setVariantRenderData,
  onDirtyField,
  isReadOnly
}) => {
  return (
    <div className="formula">
      <QueryBuilder
        type={`functionAggregation`}
        setVariantRenderData={setVariantRenderData}
        typoIndex={typoIndex}
        variantInfo={variantInfo}
        variantIndex={variantIndex}
        isReadOnly={isReadOnly}
        allowNewIfEmpty={true}
        onDirtyField={onDirtyField}
        queryValue={variantInfo.functionAggregation}
      />
    </div>
  );
};

export default Formula;
